import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { KeyboardIcon } from "components/common/Icons/KeyboardIcon";
import { Option } from "../Option/Option";
import { useKeyboard } from "./useKeyboard";

interface KeyboardProps {
    textBoxId: string;
}

export const Keyboard = ({ textBoxId }: KeyboardProps) => {
    const { handleClick } = useKeyboard(textBoxId);
    return <Option icon={<KeyboardIcon />} text={capitalize(translateFunc("keyboard"))} onClick={handleClick} />;
};
